import { Component, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { HeaderBreadcrumbService } from '../../header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { PaymentsService } from 'src/app/services/payments-services/payments.service';

@Component({
  selector: 'app-payments-gateways-dashboard',
  templateUrl: './payments-gateways-dashboard.component.html',
  styleUrls: ['./payments-gateways-dashboard.component.scss']
})
export class PaymentsGatewaysDashboardComponent implements OnInit, OnDestroy {

  gateways;
  providers;
  types;
  filterOpts;
  filterKey;
  noItemsConfig;
  viewDisposition = 'grid';
  getGatewaysSubscription: Subscription;
  getProvidersSubscription: Subscription;
  getTypesSubscription: Subscription;
  searchGatewaysSubscription: Subscription;
  filterGatewaysSubscription: Subscription;
  getGatewaysSubscriptionRefresh: Subscription;
  toggleGatewaysDispositionSubscription: Subscription;

  constructor(private paymentsService: PaymentsService,
              private snackbarService: SnackBarService,
              private cd: ChangeDetectorRef,
              private headerBreadcrumbService: HeaderBreadcrumbService) {
                this.noItemsConfig = this.setNoItemsConfig();
              }

  ngOnInit() {
    this.setBreadcrumb();
    this.getGateways();
    this.getProviders();
    this.getTypes();
    this.getGatewaysSubscriptionRefresh = this.paymentsService.listenRefreshGateways().subscribe(
      (res) => {
        this.getGateways();
      }
    );
    this.filterGatewaysSubscription = this.paymentsService.listenFilterGateways().subscribe(
      (res) => {
        this.filterOpts = res;
        this.cd.detectChanges();
      }
    );
    this.searchGatewaysSubscription = this.paymentsService.listenSearchGateways().subscribe(
      (res) => {
        this.filterKey = res;
      }
    );
    this.toggleGatewaysDispositionSubscription = this.paymentsService.listenToggleGatewaysDisposition().subscribe(
      (res) => {
        this.viewDisposition = res;
      }
    );
  }

  private getGateways() {
    this.getGatewaysSubscription = this.paymentsService.getGateways().subscribe(
      (res) => {
        this.gateways = res;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private getProviders() {
    this.getProvidersSubscription = this.paymentsService.getProviders().subscribe(
      (res) => {
        this.providers = res;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private getTypes() {
    this.getTypesSubscription = this.paymentsService.getTypes().subscribe(
      (res) => {
        this.types = res;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-cash-register', 'gateways-page.gateways', '/payments', [new BRoute('gateways-page.payments', '/payments'), new BRoute('gateways-page.gateways')]));
  }

  private setNoItemsConfig() {
    return {
      description: 'gateways-page.gateways not found',
      action: '',
      lottieConfig: {
        path: 'assets/lottie-animations/empty-list.json',
        renderer: 'canvas',
        autoplay: true,
        loop: true
      }
    };
  }

  ngOnDestroy() {
    if (this.getGatewaysSubscription) { this.getGatewaysSubscription.unsubscribe(); }
    if (this.getProvidersSubscription) { this.getProvidersSubscription.unsubscribe(); }
    if (this.getTypesSubscription) { this.getTypesSubscription.unsubscribe(); }
    if (this.searchGatewaysSubscription) { this.searchGatewaysSubscription.unsubscribe(); }
    if (this.filterGatewaysSubscription) { this.filterGatewaysSubscription.unsubscribe(); }
    if (this.getGatewaysSubscriptionRefresh) { this.getGatewaysSubscriptionRefresh.unsubscribe(); }
    if (this.toggleGatewaysDispositionSubscription) { this.toggleGatewaysDispositionSubscription.unsubscribe(); }
  }

}
